import {
    AllDataTypes,
    AntimicrobialResistanceRecords,
    CauseAssociatedComorbidityStudyCoefficients,
    CauseAssociatedCoprevalenceRecords,
    CauseCoprevalenceRecords,
    CauseOutcome,
    CovariateRecords,
    Covid19Records,
    EDPOnetimeIndicators,
    EDPTimelineIndicators,
    EtiologyRecords,
    ExpenditureRecords,
    HealthThreatsMetricsRecords,
    ImpairmentRecords,
    InjuryRecords,
    LifeExpectancyRecords,
    MultipleMyelomaOutputShell,
    MultipleMyelomaPopulation,
    MultipleMyelomaSurvivalResults,
    PopulationRecords,
    ProjectedComorbidityCausesOutcomeRecords,
    RaceEthnicityEyeConditionsRecords,
    RiskAttribution,
    RiskExposureRecords,
    RiskPrevalence,
    SdohRecords,
    SequelaOutcome,
    SevRecords,
    TakedaDengueRecords,
} from '../../models/data-type';

export default {
    [`data_type_${AllDataTypes}`]: 'All Types',
    [`data_type_${CauseOutcome}`]: 'Cause',
    [`data_type_${RiskExposureRecords}`]: 'Risk Exposure',
    [`data_type_${SequelaOutcome}`]: 'Sequela',
    [`data_type_${RiskAttribution}`]: 'Risk Burden',
    [`data_type_${RiskPrevalence}`]: 'Risk Prevalence',
    [`data_type_${EtiologyRecords}`]: 'Etiology',
    [`data_type_${ImpairmentRecords}`]: 'Impairment',
    [`data_type_${InjuryRecords}`]: 'Injury',
    [`data_type_${SevRecords}`]: 'SEV',
    [`data_type_${CovariateRecords}`]: 'Covariate',
    [`data_type_${SdohRecords}`]: 'SDoH',
    [`data_type_${PopulationRecords}`]: 'Population',
    [`data_type_${Covid19Records}`]: 'Covid-19',
    [`data_type_${EDPOnetimeIndicators}`]: 'Early Detection Onetime Indicators',
    [`data_type_${EDPTimelineIndicators}`]: 'Early Detection Timeline Indicators',
    [`data_type_${CauseCoprevalenceRecords}`]: 'Current Co-Prevalence',
    [`data_type_${CauseAssociatedCoprevalenceRecords}`]: 'Associated Current Co-Prevalence',
    [`data_type_${ProjectedComorbidityCausesOutcomeRecords}`]: 'Projected New Cases',
    [`data_type_${CauseAssociatedComorbidityStudyCoefficients}`]: 'Projected New Cases',
    [`data_type_${LifeExpectancyRecords}`]: 'Life Expectancy',
    [`data_type_${AntimicrobialResistanceRecords}`]: 'Antimicrobial Resistance',
    [`data_type_${MultipleMyelomaOutputShell}`]: 'Multiple myeloma output shell',
    [`data_type_${MultipleMyelomaSurvivalResults}`]: 'Multiple myeloma survival results',
    [`data_type_${MultipleMyelomaPopulation}`]: 'Population',
    [`data_type_${HealthThreatsMetricsRecords}`]: 'Health Threats Metrics',
    [`data_type_${RaceEthnicityEyeConditionsRecords}`]: 'Eye Conditions',
    [`data_type_${TakedaDengueRecords}`]: 'Takeda Dengue',
    [`data_type_${ExpenditureRecords}`]: 'Expenditure',
};
